var _path, _path2, _path3, _path4, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfiansaLapaz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m64.84,2.34H10.16c-1.64,0-2.97,1.33-2.97,2.97h60.61c0-1.64-1.33-2.97-2.97-2.97Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.16,72.66h54.67c1.64,0,2.97-1.33,2.97-2.97H7.2c0,1.64,1.33,2.97,2.97,2.97Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.2,5.36c-1.64,0-2.97,1.33-2.97,2.97v58.25c0,1.64,1.33,2.97,2.97,2.97V5.36Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m67.8,5.36v64.19c1.64,0,2.97-1.33,2.97-2.97V8.32c0-1.64-1.33-2.97-2.97-2.97Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "43.46 54.74 43.46 42.44 55.39 42.44 55.39 31.26 43.46 31.26 43.46 18.96 31.54 18.96 31.54 31.26 19.61 31.26 19.61 42.44 31.54 42.44 31.54 54.74 43.46 54.74"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiansaLapaz);
export default __webpack_public_path__ + "static/media/confiansa_la paz.6a13329865ad3f0abc461266ac96b2ba.svg";
export { ForwardRef as ReactComponent };